import { Divider } from "antd-v5"
import React, { useEffect, useState } from "react"
import GlobalSidebar from "./GlobalSidebar"
import AntdSwitch from "./AntdSwitch"
import { AntdInput, AntdSelect1, SidebarList } from "."
import { useAppDispatch, useAppSelector } from "hooks"
import useSchedulesQueryParams from "hooks/useSchedulesQueryParams"
import { filteredListBySearch, getAllActiveEmployees, isEmployeeLoading } from "store/Employee/detail.slice"
import { getPayGroup } from "store/PayGroups/payGroup.slice"
import { getBranches, selectBranchList } from "store/Branches/branch.slice"
import { getSDQualifications } from "store/StaticData/SDQualifications.slice"
import { getSDCounties } from "store/StaticData/SDCounties.slice"
import { getSDSuppliers, selectSDSuppliersDropdownList } from "store/StaticData/SDSuppliers.slice"
import { CaretDownOutlined, SearchOutlined } from "@ant-design/icons"

const EmployeeSidebar: React.FC = () => {
	const dispatch = useAppDispatch()
	const {
		selectedEmployeeBranch: paramEmployeeBranch,
		selectedSupplier: paramSupplier,
		selectedEmployee: paramEmployee,
		activeOnly = 'true',
		selectEmployeeBranch,
		selectSupplier,
		selectEmployee,
		selectActiveOnly
	} = useSchedulesQueryParams()

	const loading = useAppSelector(isEmployeeLoading())
	const supplierList = useAppSelector(selectSDSuppliersDropdownList)
	const branches = useAppSelector(selectBranchList())

	const shouldShowActiveOnly = activeOnly === "true"

	//const [shouldShowActiveOnly, setShouldShowActiveOnly] = useState(true)
	const [searchString, setSearchString] = useState("")
	const [searchOnFields] = useState(["shortName", "firstName", "lastName"])

	const filteredEmployeeList = useAppSelector(
		filteredListBySearch(searchString, searchOnFields, shouldShowActiveOnly, paramEmployeeBranch, paramSupplier),
	)

	useEffect(() => {
		dispatch(getPayGroup())
		dispatch(getBranches(false))
		dispatch(getSDQualifications())
		dispatch(getSDCounties())
		dispatch(getSDSuppliers(false))
	}, [])

	// Removed default selection useEffect. Moved to useEmployeeScheduleDefaults in Employee.tsx

	const handleSelected = (employeeId: string) => {
		if (employeeId !== paramEmployee) {
			selectEmployee(employeeId)
		}
	}

	const handleBranchSelected = (value: string) => {
		if (value) {
			selectEmployeeBranch(value)
		}
	}
	const handleSupplierSelected = (value: string) => {
		if (value) {
			selectSupplier(value)
		}
	}

	useEffect(() => {
		dispatch(getAllActiveEmployees(shouldShowActiveOnly))
	}, [shouldShowActiveOnly])

	return (
		<GlobalSidebar>
			<div className="h-full">
				<div className="flex flex-col space-y-2">
					<div className="flex flex-row items-center justify-between">
						<span className="text-md font-medium tracking-wider text-gray-400">EMPLOYEES</span>
						<AntdSwitch
							checked={shouldShowActiveOnly}
							checkedChildren="Active"
							unCheckedChildren="Inactive"
							onChange={value => {
								//setShouldShowActiveOnly(value)
								selectActiveOnly(value)
								dispatch(getAllActiveEmployees(value))
							}}
						/>
					</div>
					<AntdSelect1
						onChange={handleBranchSelected}
						value={paramEmployeeBranch}
						placeholder="Select branch"
						options={[{ name: "Select Branch", _id: "" }, ...branches].map(({ _id, name }) => ({
							label: name,
							value: _id,
						}))}
						suffixIcon={
							<>
								<span style={{ color: "rgb(156 163 175)" }}>Branches</span>
								<CaretDownOutlined style={{ color: "rgb(156 163 175)" }} />
							</>
						}
					/>
					<AntdSelect1
						onChange={handleSupplierSelected}
						value={paramSupplier}
						placeholder="Select Supplier"
						options={supplierList.map(({ label, value }) => ({ label, value }))}
						suffixIcon={
							<>
								<span style={{ color: "rgb(156 163 175)" }}>Suppliers</span>
								<CaretDownOutlined style={{ color: "rgb(156 163 175)" }} />
							</>
						}
					/>
					<AntdInput
						id="sidebar-search"
						onChange={e => setSearchString(e.target.value)}
						value={searchString}
						placeholder="Search"
						type="text"
						suffix={
							<>
								<span style={{ color: "rgb(156 163 175)" }}>Ctrl + G</span>
								<SearchOutlined size={14} style={{ color: "rgb(156 163 175)" }} />{" "}
							</>
						}
					/>
				</div>
				<Divider className="bg-slate-700" />
				<SidebarList
					loading={loading}
					selected={paramEmployee}
					setSelected={handleSelected}
					list={filteredEmployeeList.map(({ _id, shortName, firstName, lastName, isActive = true }) => ({
						_id,
						name: shortName || `${firstName} ${lastName}`,
						isActive,
					}))}
				/>
			</div>
		</GlobalSidebar>
	)
}

export default EmployeeSidebar
